import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
// import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";
import logo from "../../../logo.svg";
import {
  useAddSettingsMutation,
  useSettingsQuery,
} from "../../../services/settingsApi";
import { JwtReValidate, signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
//icons
import { IoSave } from "react-icons/io5";

const ProductPageSettings = () => {
  const user = signInUser();
  const { aamarId } = user;
  const lang = useSelector((state) => state.languageReducer);
  const { data: settings, isSuccess, refetch } = useSettingsQuery(aamarId);
  const [addSettings] = useAddSettingsMutation();
  const [isEcommerceToggled, setIsEcommerceToggled] = useState(false);
  const [selectedImage, setSelectedImage] = useState("image1");

  const { register, handleSubmit } = useForm();

  // Handle form submission
  const onSubmit = async (data, message) => {
    const payload = {
      ...data,
      aamarId: aamarId,
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();

      refetch();
      notify(message, "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  return (
    <div>
      {/* Product Page Settings Section */}
      <form
        style={{ marginTop: "80px" }}
        onSubmit={handleSubmit((data) =>
          onSubmit(data, "Product Page settings updated successfully!")
        )}
      >
        <div className="mb-4">
          <div className="d-flex justify-content-between">
            <h5 className="d-flex align-content-center gap-2">
              {/* <Icons.ProductOutline /> */}
              Product Page Settings
            </h5>
          </div>
          <hr />

          {/* Single Product Design */}
          <div className="d-flex justify-content-between mb-4 mt-3">
            <span className="d-flex align-content-center gap-2">
            Single Product Design
            </span>
            <div className="image-selection d-flex gap-3">
              {[
                { key: "image1", label: "Design 1" },
                { key: "image2", label: "Design 2" },
                { key: "image3", label: "Design 3" },
              ].map((item, index) => (
                <div
                  key={index}
                  onClick={() =>
                    !isEcommerceToggled && setSelectedImage(item.key)
                  }
                  className={`theme-option text-center ${
                    selectedImage === item.key ? "selected" : ""
                  }`}
                  style={{
                    border:
                      selectedImage === item.key
                        ? "1px solid #F2652D"
                        : "1px solid #ccc",
                    padding: "5px",
                    cursor: isEcommerceToggled ? "not-allowed" : "pointer",
                    borderRadius: "8px",
                    opacity: isEcommerceToggled ? 0.5 : 1,
                  }}
                >
                  <img
                    src={logo}
                    alt={item.label}
                    className="theme-image mb-2"
                    style={{ width: "250px", height: "150px" }}
                  />
                  <div style={{ fontSize: "14px", color: "#333" }}>
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Quick View Style */}
          <div className="d-flex justify-content-between mb-4 mt-3">
            <span className="d-flex align-content-center gap-2">
            Quick View Style
            </span>
            <div className="image-selection d-flex gap-3">
              {[
                { key: "image1", label: "View 1" },
                { key: "image2", label: "View 2" },
                { key: "image3", label: "View 3" },
              ].map((item, index) => (
                <div
                  key={index}
                  onClick={() =>
                    !isEcommerceToggled && setSelectedImage(item.key)
                  }
                  className={`theme-option text-center ${
                    selectedImage === item.key ? "selected" : ""
                  }`}
                  style={{
                    border:
                      selectedImage === item.key
                        ? "1px solid #F2652D"
                        : "1px solid #ccc",
                    padding: "5px",
                    cursor: isEcommerceToggled ? "not-allowed" : "pointer",
                    borderRadius: "8px",
                    opacity: isEcommerceToggled ? 0.5 : 1,
                  }}
                >
                  <img
                    src={logo}
                    alt={item.label}
                    className="theme-image mb-2"
                    style={{ width: "250px", height: "150px" }}
                  />
                  <div style={{ fontSize: "14px", color: "#333" }}>
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* List Layout Selection */}

          <div className="d-flex justify-content-between mb-4 mt-3">
            <span className="d-flex align-content-center gap-2">
              Product List Layout
            </span>
            <div className="image-selection d-flex gap-3">
              {[
                { key: "image1", label: "Grid" },
                { key: "image2", label: "List" },
              ].map((item, index) => (
                <div
                  key={index}
                  onClick={() =>
                    !isEcommerceToggled && setSelectedImage(item.key)
                  }
                  className={`theme-option text-center ${
                    selectedImage === item.key ? "selected" : ""
                  }`}
                  style={{
                    border:
                      selectedImage === item.key
                        ? "1px solid #F2652D"
                        : "1px solid #ccc",
                    padding: "5px",
                    cursor: isEcommerceToggled ? "not-allowed" : "pointer",
                    borderRadius: "8px",
                    opacity: isEcommerceToggled ? 0.5 : 1,
                  }}
                >
                  <img
                    src={logo}
                    alt={item.label}
                    className="theme-image mb-2"
                    style={{ width: "250px", height: "150px" }}
                  />
                  <div style={{ fontSize: "14px", color: "#333" }}>
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="row mb-2">
            {/* Wishlist Toggle */}
            <div className="row mb-2 col-sm-3">
              <label className=" col-form-label">Enable Wishlist</label>
              <div className="col-sm-8">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="wishlist"
                    {...register("productPage.wishlist")}
                  />
                  <label className="form-check-label" htmlFor="wishlist">
                    Enable
                  </label>
                </div>
              </div>
            </div>

            {/* Compare Toggle */}
            <div className="row mb-2 col-sm-3">
              <label className=" col-form-label">Enable Compare</label>
              <div className="">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="compare"
                    {...register("productPage.compare")}
                  />
                  <label className="form-check-label" htmlFor="compare">
                    Enable
                  </label>
                </div>
              </div>
            </div>

            {/* Reviews Toggle */}
            <div className="row mb-2 col-sm-3">
              <label className=" col-form-label">Enable Reviews</label>
              <div className="">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="reviews"
                    {...register("productPage.reviews")}
                  />
                  <label className="form-check-label" htmlFor="reviews">
                    Enable
                  </label>
                </div>
              </div>
            </div>

            {/* Related Products Toggle */}
            <div className="row mb-2 col-sm-3">
              <label className="col-form-label">Show Related Products</label>
              <div className="">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="relatedProducts"
                    {...register("productPage.relatedProducts")}
                  />
                  <label className="form-check-label" htmlFor="relatedProducts">
                    Enable
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Submit */}
          <div className="d-flex justify-content-end mt-4">
            <button
              type="submit"
              className="btn btn-dark d-flex justify-content-center align-items-center gap-2"
            >
              <IoSave size={16} className="me-1" />
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default ProductPageSettings;
